export interface UnitOfMeasurementType {
    id: number;
    name: string;
    description: string;
}
